export default "__VITE_ASSET__DkSNQCUH__"